import callApi, { CallApiResult, isAdminContext } from 'src/api';
import { CartOfferRequestDTO } from 'src/entities/cart/request/CartOfferRequestDTO';
import CartRequestDTO from 'src/entities/cart/request/CartRequestDTO';

/**
 * Executes an ordering/calc request
 */
export const orderingCalc = (data: CartRequestDTO | CartOfferRequestDTO): Promise<CallApiResult> => {
    return callApi('/ordering/calc', { method: 'POST', data });
};

/**
 * Executes an ordering/calcv2 request
 */
export const orderingCalcV2 = (data: CartRequestDTO | CartOfferRequestDTO): Promise<CallApiResult> => {
    return callApi('/ordering/calcv2', { method: 'POST', data });
};

/**
 * Submit Booking API Request
 */
export const submitBooking = (data: CartRequestDTO): Promise<CallApiResult> => {
    if (isAdminContext()) {
        return callApi('/ordering/adminOrder', { method: 'POST', data: data as CartRequestDTO });
    }
    return callApi('/ordering/prepare', { method: 'POST', data });
};

/**
 * Retrieve the offer pdf document
 */
export const retrieveOfferDocument = (publicId: string): Promise<CallApiResult> => {
    return callApi(`/api/officeProfiOrder/${publicId}/pdf`, { method: 'GET', responseType: 'blob' });
};
